exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_wks-ext.js
// module id = 19
// module chunks = 0